/**
 * API методы для аутентификации: login, logout, getCurrentUser
 * Дата: обновлено 05.02.2026 - TODO-054: добавлены OTP методы
 */
import { apiClient } from './client';
import { 
  LoginRequest, 
  LoginResponse,
  OTPSendRequest,
  OTPSendResponse,
  OTPVerifyRequest,
  OTPVerifyResponse
} from './types';

export const authApi = {
  login: async (data: LoginRequest): Promise<LoginResponse> => {
    const response = await apiClient.post<LoginResponse>('/auth/login', data);
    return response.data;
  },

  logout: async (): Promise<void> => {
    await apiClient.post('/auth/logout');
  },

  getCurrentUser: async () => {
    const response = await apiClient.get('/auth/me');
    return response.data;
  },

  // ═══════════════════════════════════════════════════════════════════════════
  // OTP Login (TODO-054, 05.02.2026)
  // ═══════════════════════════════════════════════════════════════════════════

  /**
   * Отправить OTP код на телефон
   * @param data - номер телефона и флаг use_fallback
   */
  otpSend: async (data: OTPSendRequest): Promise<OTPSendResponse> => {
    const response = await apiClient.post<OTPSendResponse>('/auth/otp-send', data);
    return response.data;
  },

  /**
   * Верифицировать OTP код и получить токен
   * @param data - номер телефона и код
   */
  otpVerify: async (data: OTPVerifyRequest): Promise<OTPVerifyResponse> => {
    const response = await apiClient.post<OTPVerifyResponse>('/auth/otp-verify', data);
    return response.data;
  },
};

